import React, { useEffect, useState } from 'react';
import { ReactComponent as IconTimen } from "../assets/image/sessionEnd.svg";
import { Modal } from 'antd';

export const TokenExpired = () => {

  const [modal, contextHolder] = Modal.useModal();
  const [flag, setFlag] = useState(false);
  const countDown = () => {
    let secondsToGo = 10;
    const instance = modal.success({
      title: (<div className='text-center'>Completed Session</div>),
      icon: null,
      content: (
        <div className='text-center w-full ml-4'>
          <p>Your session has expired, please enter again</p>
          <div className='justify-center items-center text-center flex'>
            <IconTimen className="w-28 h-28 fill-pc-purple m-1 " ></IconTimen>
          </div>
        </div>
      ),
      okButtonProps: { className: 'block mx-auto mt-4 bg-pc-purple border-pc-purple text center' },
    });

    setTimeout(() => {
      instance.destroy();
    }, secondsToGo * 1000);
  };

  useEffect(() => {
    if (!flag) {
      setFlag(true);
      countDown();
    }
  }, [])
  return (
    <>
      {contextHolder}
    </>
  );
};
